export default "__VITE_ASSET__C2bEG6z0__"